import { useState } from 'react';
import { useGoogleIdPSync, useGoogleIdPSyncDryRun, useTestGoogleIdP } from '#api/google-idp.queries.ts';
import { Button } from '#components/atoms/buttons/Button.tsx';
import { GoogleDirectorySyncDialog, testThenPreview } from './GoogleDirectorySyncDialog.tsx';

/**
 * {@link GoogleDirectoryTestButton} checks that Google still accepts the directory connection, then shows how the
 * directory differs from the users Defined Networking knows, without changing anything.
 */
export function GoogleDirectoryTestButton() {
  const [open, setOpen] = useState(false);
  const test = useTestGoogleIdP();
  const dryRun = useGoogleIdPSyncDryRun();
  const sync = useGoogleIdPSync();

  // Started from the click, not from an effect in the dialog; see GoogleDirectorySyncDialog's props for why.
  function start() {
    sync.reset();
    testThenPreview(test, dryRun);
    setOpen(true);
  }

  return (
    <>
      <Button variant="secondary" onClick={start}>
        Test connection
      </Button>
      {open ?
        <GoogleDirectorySyncDialog onClose={() => setOpen(false)} test={test} dryRun={dryRun} sync={sync} />
      : null}
    </>
  );
}
